import { gql } from 'graphql-request';

import {
  LifestylesSetID,
  LifestylesSetSelectedLifestylesID,
  LifestylesSetSelectedLifestylesLifestyleBlocked,
  LifestylesSetSelectedLifestylesLifestyleCategoryLocalizedName,
  LifestylesSetSelectedLifestylesLifestyleCategoryName,
  LifestylesSetSelectedLifestylesLifestyleCategoryUUID,
  LifestylesSetSelectedLifestylesLifestyleFavorite,
  LifestylesSetSelectedLifestylesLifestyleID,
  LifestylesSetSelectedLifestylesLifestyleImageFile,
  LifestylesSetSelectedLifestylesLifestyleImageUUID,
  LifestylesSetSelectedLifestylesLifestyleName,
  LifestylesSetSelectedLifestylesLifestyleNanoID,
  LifestylesSetSelectedLifestylesLifestyleNda,
  LifestylesSetSelectedLifestylesLifestyleUUID,
  LifestylesSetSelectedLifestylesUUID,
  LifestylesSetUUID
} from '../lifestylesSetsTypes';

export interface FetchLifestylesSetByUserIdQueryResponse {
  id: LifestylesSetID;
  uuid: LifestylesSetUUID;
  selectedLifestyles: {
    id: LifestylesSetSelectedLifestylesID;
    uuid: LifestylesSetSelectedLifestylesUUID;
    lifestyleId: LifestylesSetSelectedLifestylesLifestyleID;
    lifestyle: {
      id: LifestylesSetSelectedLifestylesLifestyleID;
      uuid: LifestylesSetSelectedLifestylesLifestyleUUID;
      nanoId: LifestylesSetSelectedLifestylesLifestyleNanoID;
      name: LifestylesSetSelectedLifestylesLifestyleName;
      nda: LifestylesSetSelectedLifestylesLifestyleNda;
      blocked: LifestylesSetSelectedLifestylesLifestyleBlocked;
      favorite: LifestylesSetSelectedLifestylesLifestyleFavorite;
      image: {
        uuid: LifestylesSetSelectedLifestylesLifestyleImageUUID;
        file: LifestylesSetSelectedLifestylesLifestyleImageFile;
      };
      category: {
        uuid: LifestylesSetSelectedLifestylesLifestyleCategoryUUID;
        name: LifestylesSetSelectedLifestylesLifestyleCategoryName;
        localizedName: LifestylesSetSelectedLifestylesLifestyleCategoryLocalizedName;
      };
    };
  }[];
}

export const FETCH_LIFESTYLES_SET_BY_USER_ID_QUERY = gql`
  query LifestylesSetByUserId($userId: ID!, $scope: ID) {
    lifestylesSetByUserId(userId: $userId, scope: $scope) {
      id
      uuid
      selectedLifestyles {
        id
        uuid
        lifestyleId
        lifestyle {
          id
          uuid
          nanoId
          name
          nda
          blocked
          favorite
          image {
            uuid
            file
          }
          category {
            uuid
            name
            localizedName
          }
        }
      }
    }
  }
`;
